import React from 'react'
import {
  Section,
  Heading,
  Subheading,
  Grid,
  Card,
  Photo,
  Numero,
  Body,
  Name,
  Text
} from './IngredientesSection.elements'
import { Container } from '../../globalStyles'

const IngredientesSection = ({ ingredientes, titulo, subtitulo }) => {
  return (
    <Section>
      <Container>
        <Heading>{titulo}</Heading>
        {subtitulo && <Subheading>{subtitulo}</Subheading>}

        <Grid>
          {ingredientes.map((item, i) => (
            <Card key={item.title}>
              <Photo>
                <Numero>{String(i + 1).padStart(2, '0')}</Numero>
                <img src={item.img} alt={item.title} loading="lazy" />
              </Photo>
              <Body>
                <Name>{item.title}</Name>
                <Text>{item.text}</Text>
              </Body>
            </Card>
          ))}
        </Grid>
      </Container>
    </Section>
  )
}

export default IngredientesSection
